import { fetcher } from '@commenda/utils';
import { UpdateSettingsPayload, UpdateSettingsResponse } from './types';

export async function updateIntegrationSettings(
  body: UpdateSettingsPayload
): Promise<{
  success: boolean;
  data?: UpdateSettingsResponse;
  error?: unknown;
}> {
  try {
    const response = await fetcher(`rootfi/${body.rootfiCompanyId}/settings?corporationId=${body.corporationId}`, {
      method: 'PATCH',
      body: {
        taxCalculationEnabled: body.taxCalculationEnabled,
        taxCalculationStartDate: body.taxCalculationStartDate,
        syncEnabled: body.syncEnabled,
        platformSettings: body.platformSettings,
        dataModelSyncSettings: body.dataModelSyncSettings,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update settings',
      };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to update settings';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
